import React, { Component } from "react";
import "./bulk-upload.styles.css";

import { selectUserData } from "../../redux/user/user.selectors";
import {
  Spin,
  Button,
  Typography,
  Row,
  Col,
  Card,
  Breadcrumb,
  Tag,
  Icon,
} from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  Link,
  withRouter,
  Switch as RouteSwitch,
  Route,
} from "react-router-dom";
import moment from "moment";
import agriculture from "../../assets/agriculture.svg";
import local_shipping from "../../assets/local_shipping.svg";
import { setCurrentArrivalScreen } from "../../redux/map/map.actions";
import {
  setScreenName,
  setScreenType,
} from "../../redux/arrival-entry/arrival-entry.actions";
import {
  selectScreenName,
  selectScreenType,
} from "../../redux/arrival-entry/arrival-entry.selectors";

/**
 * @component
 * @description The parent component for bulk upload page.
 *
 *
 */
class BulkUpload extends Component {
  state = {
    isSpinnerOn: false,
    isSubmitted: false,
  };

  render() {
    const { setScreenName, setScreenType } = this.props;

    return (
      <Spin spinning={this.state.isSpinnerOn} tip="Loading...">
        <div
          className="bulkupload-page-container"
          // style={{ height: window.innerHeight - 85 }}
        >
          <Breadcrumb
            separator={
              <Icon
                type="right"
                style={{ color: "#002045", fontSize: 10, fontWeight: 700 }}
              />
            }
            style={{ marginBottom: 20 }}
          >
            <Breadcrumb.Item>Arrival</Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#002045", fontWeight: 500 }}>
              Bulk Upload
            </Breadcrumb.Item>
          </Breadcrumb>
          <Tag
            color="rgb(216, 216, 216)"
            style={{
              width: "fit-content",
              padding: 10,
              borderRadius: 10,
              marginBottom: 20,
            }}
          >
            <Typography.Text style={{ fontSize: 13, fontWeight: 500 }}>
              <Icon
                type="calendar"
                style={{ fontSize: 16, paddingRight: 10 }}
              />
              Data can be uploaded for: {moment().format("MMMM DD, YYYY")}
            </Typography.Text>
          </Tag>
          <Typography.Title
            level={2}
            style={{ marginBottom: 10, fontWeight: 700 }}
          >
            Bulk Data Upload
          </Typography.Title>
          <Row style={{ marginBottom: 20 }}>
            <Col span={14}>
              <Typography.Paragraph>
                Select the appropriate category to begin your bulk data
                ingestion. Ensure your Excel templates follow the standardized
                ASTRA format. You can download the template in next step.
              </Typography.Paragraph>
            </Col>
          </Row>
          <Row gutter={32}>
            <Col span={12}>
              <Card
                actions={[
                  <Button
                    onClick={() => {
                      setScreenName(2);
                      setScreenType("mandi");
                    }}
                    style={{
                      width: "80%",
                      height: 40,
                      // background: "#0061a5",
                      color: "#fff",
                      fontWeight: 500,
                    }}
                  >
                    Proceed to Upload <Icon type="arrow-right" />
                  </Button>,
                ]}
                className="upload-card-hover"
              >
                <Row gutter={[0, 18]}>
                  <Col span={24}>
                    <span>
                      <img className="iconinfo" src={agriculture} alt="info" />
                    </span>
                  </Col>
                  <Col span={24}>
                    <Typography.Title
                      level={4}
                      style={{ fontWeight: 500, margin: 0 }}
                    >
                      Mandi Data
                    </Typography.Title>
                  </Col>
                  <Col span={24}>
                    <Typography.Paragraph>
                      Efficiently upload records from local agricultural
                      markets. Manage daily arrivals, modal prices, and
                      variety-specific data across multiple Mandi locations
                      simultaneously.
                    </Typography.Paragraph>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />{" "}
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Supports multiple varieties (Dara, Lokwan, etc.)
                    </Typography.Text>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />{" "}
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Quality based arrival mapping
                    </Typography.Text>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />{" "}
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Regional hub grouping for easy filtering
                    </Typography.Text>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                actions={[
                  <Button
                    onClick={() => {
                      setScreenName(2);
                      setScreenType("for");
                    }}
                    style={{
                      width: "80%",
                      height: 40,
                      // background: "#0061a5",
                      color: "#fff",
                      fontWeight: 500,
                    }}
                  >
                    Proceed to Upload <Icon type="arrow-right" />
                  </Button>,
                ]}
                className="upload-card-hover"
              >
                <Row gutter={[0, 18]}>
                  <Col span={24}>
                    <span>
                      <img
                        className="iconinfo"
                        src={local_shipping}
                        alt="info"
                      />
                    </span>
                  </Col>
                  <Col span={24}>
                    <Typography.Title
                      level={4}
                      style={{ fontWeight: 500, margin: 0 }}
                    >
                      FOR Data
                    </Typography.Title>
                  </Col>
                  <Col span={24}>
                    <Typography.Paragraph>
                      Ingest and manage logistics data based on landed prices at
                      the hub level. Streamline transportation cost tracking and
                      purchase point arrivals for accurate regional assessment.
                    </Typography.Paragraph>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Landed price tracking at hubs
                    </Typography.Text>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Regional logistics cost validation
                    </Typography.Text>
                  </Col>
                  <Col span={1}>
                    <Icon type="check-circle" style={{ color: "green" }} />
                  </Col>
                  <Col offset={1} span={22}>
                    <Typography.Text>
                      Hub-level arrival integration
                    </Typography.Text>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setScreenType: (type) => dispatch(setScreenType(type)),
  };
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screenName: selectScreenName,
  screenType: selectScreenType,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulkUpload),
);
